import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { ISupplierInventoryApi } from './base/supplierInventoryApi';
import { Result } from '../models/common/resultResponse';
import {
  SupplierInventoryRequest,
  ImportSaveRequest,
  UpdateStatusDeletedRequest,
  SupplierInventoryVehiclesRequest
} from '../models/request/supplierInventoryRequest';
import {
  SupplierInventoryDataResponse,
  SupplierInventoryResponse,
  SupplierInventoryVehicleResponse,
  SupplierInventoryWarehousePriceResponse
} from '../models/response';
import { PaginationResponse } from '../models/common/paginationResponse';

const baseRoute: string = 'SupplierInventory';

export class SupplierInventoryApi extends ISupplierInventoryApi {
  getSearchGrid(
    request: SupplierInventoryRequest
  ): Promise<AxiosResponse<Result<SupplierInventoryResponse>>> {
    return api.post(`${baseRoute}/getSearchGridSupplierPartsCatalog`, request);
  }

  changeStatusPartsCatalog(
    request: SupplierInventoryRequest
  ): Promise<AxiosResponse<Result<void>>> {
    return api.put(
      `${baseRoute}/toggleSupplierInventoryWarehouseStatus`,
      request
    );
  }

  getInfoPart(
    request: SupplierInventoryRequest
  ): Promise<AxiosResponse<Result<SupplierInventoryDataResponse>>> {
    return api.get(
      `${baseRoute}/getPartDetailByGuidSupplierInventoryWarehouse`,
      {
        params: request
      }
    );
  }

  getVehiclesInventory(
    request: SupplierInventoryVehiclesRequest
  ): Promise<
    AxiosResponse<PaginationResponse<SupplierInventoryVehicleResponse>>
  > {
    return api.get(`${baseRoute}/getVehiclesByGuidSupplierInventory`, {
      params: request
    });
  }
  updateStatusDeleted(
    request: UpdateStatusDeletedRequest
  ): Promise<AxiosResponse<Result<boolean>, any>> {
    return api.put(
      `${baseRoute}/updateStatusDeleted`,
      request.supplierInventoryWarehouseGuid,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }
  getWarehousePartPrice(
    guidSupplierInventoryWarehouse: string
  ): Promise<AxiosResponse<Result<SupplierInventoryWarehousePriceResponse[]>>> {
    return api.get(`${baseRoute}/getWarehousePartPrice`, {
      params: { guidSupplierInventoryWarehouse }
    });
  }
}

